import Event from './Event.class'
import axios from 'axios'
import {get} from 'lodash'
import moment from 'moment'

const baseURL = '/api/event/'

export default class Module {
	/** @constructor
	 * @param {number | Object} init
	 */
	constructor (init = {}) {
		this.id = null
		this.setDefaultData()

		if (typeof init === 'number') {
			this.id = init
			this.getSingle().then()
		} else {
			this.setDefaultData(init)
		}
	}

	static getAll (params) {
		let modulesParams = {
			...params
			// 'filters[parent_id]': 'true'
		}

		return axios.get(baseURL, {
			params: modulesParams
		})
			.then(res => {
				return {
					...res.data,
					data: this.createObjectFromArray(res.data.data)
				}
			})
			.catch(err => {
				console.error(err)
				return null
			})
	}

	static getSinglePromise (id) {
		return axios.get(`/api/event/admin/${id}`)
			.then(res => {
				return new Module(res.data.data)
			})
			.catch(err => {
				console.log(err)
				return null
			})
	}
	async getSingle () {
		try {
			const {data} = await axios.get(`/api/event/admin/${this.id}`)
			this.setDefaultData(data.data)
		} catch (e) {
			console.error(e)
		}
	}
	setDefaultData (init = {}) {
		if (!init) return

		this.published = get(init, 'published') ? init.published : false
		this.published_at = get(init, 'published_at') ? new Date(init.published_at) : null
		this.id = get(init, 'id') ? init.id : null
		this.name = get(init, 'name') ? init.name : ''
		this.full_name = get(init, 'full_name') ? init.full_name : ''
		this.info = get(init, 'info') ? init.info : ''
		this.full_info = get(init, 'full_info') ? init.full_info : ''
		this.serial_number = get(init, 'serial_number') ? init.serial_number : 0
		this.parent = get(init, 'parent') ? new Event(init.parent) : new Event()
		this.parent_id = get(init, 'parent.id') ? init.parent.id : 0
		this.rich_content = get(init, 'rich_content') && init.rich_content
		? this.filterRichContent(this.createRichContent(init.rich_content)) : []
		this.is_custom_content = get(init, 'is_custom_content') ? init.is_custom_content : false
		this.custom_content = get(init, 'custom_content') ? init.custom_content : ''
		this.start_at = get(init, 'start_at') && this.isValidDate(init.start_at) ? new Date(init.start_at) : null

		// not request
		this.front_url = get(init, 'front_url') && this.parent.id ? `${init.front_url}/events/${this.parent.id}/${this.id}` : null
		this.errors = {}
		this.created_at = get(init, 'created_at') && this.isValidDate(init.created_at) ? new Date(init.created_at) : null
		this.updated_at = get(init, 'updated_at') && this.isValidDate(init.updated_at) ? new Date(init.updated_at) : null
		this.deleted_at = get(init, 'deleted_at') && this.isValidDate(init.deleted_at) ? new Date(init.deleted_at) : null
		this.progress = get(init, 'progress') ? init.progress : 0
		this.question_count = get(init, 'question_count') ? init.question_count : 0
	}
	isValidDate (date) {
		return date && isNaN(date)
	}
	static createObjectFromArray (arr) {
		return arr.map(item => new Module(item))
	}
	/**
	 * get form data
	 * @returns {FormData}
	 */
	get formData () {
		const formData = new FormData()

		if (this.name) formData.append('name', this.name)
		if (this.full_name) formData.append('full_name', this.full_name)
		if (this.info) formData.append('info', this.info)
		if (this.full_info) formData.append('full_info', this.full_info)
		formData.append('parent_id', this.parent && this.parent.id ? this.parent.id : 0)
		formData.append('start_at', this.start_at ? this.dateToServerFormat(this.start_at) : '')

		// nullable fields
		if (this.custom_content) formData.append('custom_content', this.custom_content)
		if (this.rich_content && this.rich_content.length) {
			formData.append('rich_content', this.richContentForSave())
		}
		formData.append('is_custom_content', this.is_custom_content ? 1 : 0)

		return formData
	}

	update (formData) {
		return axios.post(`${baseURL}${this.id}`, formData || this.formData)
			.then(res => {
				return res
			})
			.catch(err => {
				console.error(err)
				return err.response
			})
	}

	attach (parent) {
		this.parent = parent

		const formData = new FormData()
		formData.append('parent_id', this.parent && this.parent.id ? this.parent.id : 0)

		return this.update(formData)
	}
	detach () {
		this.parent = null

		const formData = new FormData()
		formData.append('parent_id', this.parent && this.parent.id ? this.parent.id : 0)

		return this.update(formData)
	}
	/**
	 * create event by id
	 * @returns {Promise}
	 */
	async create (formData) {
		return await axios.post(`${baseURL}`, formData || this.formData)
			.then(res => {
				return res
			})
			.catch(err => {
				console.error(err)
				return err.response
			})
	}

	async delete () {
		try {
			const res = await axios.delete(`${baseURL}${this.id}`)
			return res
		} catch (e) {
			console.error(e)
			return false
		}
	}

	static deleteById (id) {
		return axios.delete(`${baseURL}${id}`)
			.then(res => {
				return res
			})
			.catch(err => {
				console.error(err)
				return false
			})
	}
	get nameWithoutTags () {
		const regex = /<\/?[^>]+>/gi
		return this.name.replace(regex, '')
	}
	async copy () {
		return await axios.post(`${baseURL}${this.id}/copy`)
			.then(res => {
				return res
			})
			.catch(err => {
				console.error(err)
				return false
			})
	}

	restore () {
		return axios.post(`${baseURL}${this.id}/restore`)
			.then(res => {
				return res
			})
			.catch(err => {
				console.error(err)
				return false
			})
	}

	get isModule () {
		return this.parent_id > 0 || this.parent_id === 0
	}

	createErrors (obj) {
		let newObj = {}
		for (let key in obj) {
			const newErrorStr = obj[key].reduce((accumulator, item) => {
				return accumulator + item
			}, '')

			newObj[key] = newErrorStr
		}
		this.errors = newObj
	}

	createRichContent (rich) {
		if (rich) {
			try {
				const richObject = JSON.parse(rich)
				return richObject
			} catch (e) {
				return []
			}
		} else {
			return []
		}
	}

	filterRichContent (arr) {
		if (Array.isArray(arr)) {
			return arr.filter(el => el.type === 'slider' || el.type === 'content')
			.map(el => {
				return {
					...el,
					isOpenTab: true
				}
			})
		} else return []
	}

	richContentForSave () {
		const arr = this.rich_content.map(({isOpenTab, ...keepAttrs}) => keepAttrs)

		return JSON.stringify(arr)
	}

	publish () {
		const formData = new FormData()
		formData.append('date', this.published ? 0 : this.dateToServerFormat(new Date()))

		return axios.post(`${baseURL}${this.id}/publish`, formData)
			.then(res => {
				return res
			})
			.catch(err => {
				console.error(err)
				return false
			})
	}
	dateToServerFormat (date) {
		return moment(date).format('YYYY-MM-DD HH:mm:ss')
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/Module.class.js